import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';

type CurrentPlatform =
  | 'ipad'
  | 'iphone'
  | 'ios'
  | 'android'
  | 'phablet'
  | 'tablet'
  | 'cordova'
  | 'capacitor'
  | 'electron'
  | 'pwa'
  | 'mobile'
  | 'mobileweb'
  | 'desktop'
  | 'hybrid';

@Injectable({
  providedIn: 'root',
})
export class PlatformIdentityService {
  private _currentPlatform: CurrentPlatform;

  constructor(private platform: Platform) {
    this.setCurrentPlatform();
  }

  get currentPlatform() {
    return this._currentPlatform;
  }

  public isAndroid() {
    return this._currentPlatform === 'android';
  }

  public isWeb() {
    return Capacitor.getPlatform() === 'web';
  }

  public isIos() {
    return this._currentPlatform === 'ios';
  }

  public isNative() {
    return Capacitor.isNative;
  }

  public isMobileWeb() {
    return this.platform.is('mobileweb');
  }

  private setCurrentPlatform() {
    // Are we on mobile platform? Yes if platform is ios or android, but not desktop or mobileweb, no otherwise
    if (this.platform.is('android') || this.platform.is('mobileweb')) {
      this._currentPlatform = 'android';
    }

    if (this.platform.is('ios')) {
      this._currentPlatform = 'ios';
    }
  }
}
